<section
  class="w-full flex border-l-4 border-aux-blue"
  [class]="className"
  [ngClass]="{ 'bg-aux-gray-light': !locked, 'bg-aux-blue-dark': locked }"
>
  <ng-container *ngIf="(isLoading$ | async) === false">
    <div class="flex flex-row items-center justify-center border border-aux-gray-dark">
      <span
        inlineSVG="arrow-left-circle.svg"
        class="m-1.5"
        [ngClass]="{ 'text-aux-blue': !locked, 'text-white': locked }"
      ></span>

      <a
        style="margin-left: -1rem"
        class="aux-link text-sm text-center"
        [ngClass]="{ 'text-aux-blue': !locked, 'text-white': locked }"
        [routerLink]="[quarterCloseChecklistLink]"
      >
        Close Checklist
      </a>
    </div>

    <div class="grid grid-cols-1 w-full">
      <aux-workflow-panel-general-item
        [workflowName]="workflowName"
        [isAdminUser]="isAdminUser"
        [headerTextCallback]="getHeaderFn"
        [auditTextCallback]="getTitleFn"
        [lockAvailable]="!processing"
      >
      </aux-workflow-panel-general-item>
    </div>
  </ng-container>

  <div class="border-8 m-auto spinner h-16 w-16" *ngIf="isLoading$ | async"></div>
</section>
